// test982
(982 && 0);
